import { z } from "zod";

import { TALENT_REFERRALS_ORDER_BY } from "../../constants";

export const schemaForTalentReferralsFilters = z.object({
  order_by: z.nativeEnum(TALENT_REFERRALS_ORDER_BY).optional(),
  order_dir: z.union([z.literal("asc"), z.literal("desc")]).optional(),
  search: z.string().optional(),
});
